import React from "react";
import ButtonUnstyled from "@mui/base/ButtonUnstyled";
import {ArrowBack, ArrowForward} from "@mui/icons-material";
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  footer: {
    flex: '0 1 10%',
    height: '68px',
    position: 'relative',
    bottom: 0,
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 5px rgba(50, 50, 50, 0.65)',
    // border: "1px solid #000000",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    ['@media (min-width: 640px)']: {
      borderRadius: '0 0 19px 19px',
    }
  },
  green: {
    background: '#829E3B',
  },
  grey: {
    background: '#E8E8E8',
  },
  button: {
    align: 'center',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '34px',
    letterSpacing: '0.1em',
    textAlign: 'center',
    border: "2px solid #000000",
    boxSizing: "border-box",
    borderRadius: '5px',
    margin: '10px',
    marginBottom: '16px',
    padding: '2px 10px 2px 10px',
    color: '#000000',
    background: 'transparent',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  arrowBack: {
    '& svg': {
      fontSize: 32
    },
    color: 'black',
  },
  arrowForward: {
    '& svg': {
      fontSize: 32
    },
    color: 'black',
  }
});

export default function Navigation(props) {
  const {previousHandler, nextHandler, buttonPath, buttonText, buttonHandler, isGreen} = props;
  const classes = useStyles();
  return (<footer className={`${classes.footer} ${isGreen ? classes.green : classes.grey}`}>
    { previousHandler ?
      <IconButton style={{color: 'black'}} className={classes.arrowBack} onClick={previousHandler}>
        <ArrowBack/>
      </IconButton>  : <ArrowBack style={{visibility: 'hidden', width: '48px'}}/>}
    { buttonHandler ?
      <ButtonUnstyled className={classes.button} onClick={buttonHandler} variant='outlined' style={{ textDecoration: 'none' }}>
        {buttonText}
      </ButtonUnstyled> : ( buttonPath ?
      <ButtonUnstyled component={Link} to={buttonPath} key={buttonPath} className={classes.button} onClick={() => window.scrollTo(0,0)} style={{ textDecoration: 'none' }}>
        {buttonText}
      </ButtonUnstyled> :
      <ButtonUnstyled className={classes.button} onClick={buttonHandler} variant='outlined' style={{ textDecoration: 'none', visibility: 'hidden' }}>
        {buttonText}
      </ButtonUnstyled>)

    }
    { nextHandler ?
      <IconButton style={{color: 'black'}} className={classes.arrowForward} onClick={nextHandler}>
        <ArrowForward/>
      </IconButton> : <ArrowForward style={{visibility: 'hidden', width: '48px'}}/>}
  </footer>);
}